<template>
  <div class="numInputs">
    <el-input
      v-for="(item,index) in amount"
      :key="index"
      v-model="arr[index]"
      maxlength="1"
      @keydown.native="nextFocus($event, index)"
      ref="numInput"
      type="tel"
      style="width:50px;height:50px"
    ></el-input>
  </div>
</template>
<script>
export default {
  props: {
    amount: {
      default: 4,
      type: Number
    }
  },
  data() {
    return {
      arr: []
    };
  },
  created() {
    setTimeout(() => {
      this.$refs.numInput[0] && this.$refs.numInput[0].focus();
    }, 0);
  },
  watch: {
    arr(val) {
      this.$emit('input', val.join(''));
    }
  },
  methods: {
    nextFocus($event, index) {
      // 键入时光标跳转
      this.arr[index] &&
        this.$refs.numInput[index + 1] &&
        this.$refs.numInput[index + 1].focus();
      // 删除
      if ($event.keyCode === 8) {
        if (this.arr[index]) {
          this.arr[index] = '';
          this.arr = JSON.parse(JSON.stringify(this.arr));
          this.$refs.numInput[index].focus();
        } else {
          this.$refs.numInput[index - 1] &&
            this.$refs.numInput[index - 1].focus();
        }
      }
    }
  }
};
</script>
<style lang="less">
.numInputs {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  .el-input:nth-child(2),.el-input:nth-child(3),.el-input:nth-child(4) {
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/num-input.vue